import { render, staticRenderFns } from "./zhibo.vue?vue&type=template&id=6e7c6ada&scoped=true&"
import script from "./zhibo.vue?vue&type=script&lang=js&"
export * from "./zhibo.vue?vue&type=script&lang=js&"
import style0 from "./zhibo.vue?vue&type=style&index=0&id=6e7c6ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c6ada",
  null
  
)

export default component.exports